<template>
   <f7-page>
    <f7-navbar>
      <f7-nav-title class="text-madai">Mi Cuenta</f7-nav-title>
    </f7-navbar>

    <f7-block class="text-center">
      <img src="@/assets/img/logo_250.png" alt="" width="100">
    </f7-block>
    <template v-if="!storage.token || storage.token === ''">
      <template v-if="formulario === 'sesion'">
        <f7-block>
          <f7-list no-hairlines-md>
            <f7-list-input
              label="Correo"
              type="text"
              placeholder="Escribe tu correo"
              :value="correo"
              @input="correo = $event.target.value"
            >
            </f7-list-input>
            <f7-list-input
              label="Contraseña"
              type="password"
              placeholder="Escribe tu contraseña"
              :value="clave"
              @input="clave = $event.target.value"
            >
            </f7-list-input>
            <f7-list-item>
              <f7-link @click="formulario = 'enviame'" class="margin-auto">
                ¿Olvidaste tu contraseña?
              </f7-link>
            </f7-list-item>
            <f7-list-item>
              <f7-button class="wd-100" fill @click="iniciarSesion()">
                Iniciar Sesión
              </f7-button>
            </f7-list-item>
          </f7-list>
        </f7-block>
        <f7-block class="m-b-100">
          <f7-list class="m-t-5" no-hairlines-md>
            <f7-list-item>
              <f7-link @click="formulario = 'cuenta'" class="margin-auto">
                Crea una cuenta nueva
              </f7-link>
            </f7-list-item>
          </f7-list>
        </f7-block>
      </template>
      <template v-else-if="formulario === 'cuenta'">
        <f7-block>
          <f7-list no-hairlines-md>
            <f7-list-input
              class="required"
              label="Nombre"
              type="text"
              placeholder="Escribe tu nombre"
              :value="nombre"
              @input="nombre = $event.target.value"
            >
            </f7-list-input>
            <f7-list-input
              class="required"
              label="Correo"
              type="text"
              placeholder="Escribe tu correo"
              :value="correo"
              @input="correo = $event.target.value"
            >
            </f7-list-input>
            <f7-list-input
              class="required"
              label="Contraseña"
              type="password"
              placeholder="Escribe una contraseña"
              :value="clave"
              @input="clave = $event.target.value"
            >
            </f7-list-input>
            <f7-list-item>
              <f7-button class="wd-100" @click="crearCuenta()" fill>
                Crear cuenta
              </f7-button>
            </f7-list-item>
          </f7-list>
        </f7-block>
        <f7-block class="m-b-100">
          <f7-list class="m-t-5" no-hairlines-md>
            <f7-list-item>
              <f7-link @click="formulario = 'sesion'" class="margin-auto">
                ¿Ya tienes una cuenta?, inicia sesión
              </f7-link>
            </f7-list-item>
          </f7-list>
        </f7-block>
      </template>
      <template v-else>
        <f7-block>
          <f7-list no-hairlines-md>
            <f7-list-input
              class="required"
              label="Correo"
              type="text"
              placeholder="Escribe tu correo"
            >
            </f7-list-input>
            <f7-list-item>
              <f7-button class="wd-100" fill>
                Envíame la contraseña
              </f7-button>
            </f7-list-item>
          </f7-list>
        </f7-block>
        <f7-block class="m-b-100">
          <f7-list class="m-t-5" no-hairlines-md>
            <f7-list-item>
              <f7-link @click="formulario = 'sesion'" class="margin-auto">
                Inicia sesión
              </f7-link>
            </f7-list-item>
          </f7-list>
        </f7-block>
      </template>
    </template>
    <template v-else>
      <f7-block class="bold text-center">
        Sesión iniciada como:
        <div class="text-madai">
          {{ storage.usuario.name }}
        </div>
      </f7-block>

      <f7-list>
        <f7-list-item title="Mi Perfil" link="/cuenta/perfil/"></f7-list-item>
        <f7-list-item title="Dirección de envío" link="/cuenta/envio/"></f7-list-item>
        <f7-list-item title="Información de facturación" link="/cuenta/facturacion/"></f7-list-item>
        <f7-list-item title="Cerrar sesión" :link="true" @click="cerrarSesion()"></f7-list-item>
      </f7-list>
    </template>

    <!-- <img src="http://www.procarcenter.cl/Mayoristas-Chile/dension-chile_files/label_proximamente.png" alt="" style="position: absolute; z-index:10;">
    <img class="wd-100" src="assets/img/banners/store_coming_soon.jpg" alt="">
    <f7-row class="text-center m-t-20">
      <f7-col>
        <span class="bold fs-18">Próximamente podrás:</span>
      </f7-col>
    </f7-row>
    <f7-row class="m-t-10">
      <f7-col>
        <div class="numberlist w-280 margin-auto">
          <ol class="m-b-0">
            <li><div>Registrarte mediante tus redes sociales favoritas</div></li>
            <li><div>Darle seguiemiento a tus pedidos</div></li>
            <li><div>Cotizar múltiples piezas</div></li>
            <li><div>Hacer pédidos</div></li>
            <li><div>Pagar fácil y seguro</div></li>
          </ol>
        </div>
      </f7-col>
    </f7-row>
    <f7-block>
      <div class="bold text-center fs-12">
        2019 Madai. Todos los derechos reservados.
      </div>
    </f7-block> -->
  </f7-page>
</template>

<script>
export default {
  data () {
    return {
      formulario: 'sesion',
      nombre: '',
      correo: '',
      clave: ''
    }
  },
  methods: {
    async iniciarSesion (nuevo) {
      try {
        let { usuario, token, envio, facturacion } = await this.$api.usuario.auth(this.correo, this.clave, nuevo)
        this.storage.token = token
        usuario.envio = envio
        usuario.facturacion = facturacion
        this.storage.usuario = usuario
      } catch (err) {
        this.$f7.dialog.alert('El usuario no existe o la contraseña es incorrecta.', `MADAI`, () => {})
      }
    },
    async crearCuenta () {
      try {
        await this.$api.usuario.nuevo({
          user: 'na',
          name: this.nombre,
          email: this.correo,
          password: this.clave
        })
        this.iniciarSesion(true)
      } catch (err) {
        this.$f7.dialog.alert('El correo que estas intentando usar ya se usó.', `MADAI`, () => {})
      }
    },
    cerrarSesion () {
      this.$api.usuario.cerrar()
      this.storage.token = ''
    }
  }
}
</script>
